<template>
	<div class="row justify-content-center no-gutters">
		<div class="col-12 content-heading" v-bind:class="parent.slug" v-html="parent.subtitle" v-if="parent"></div>
		<template v-if="loaded">
			<div v-for="licence in licences" class="col col-lg-3 col-md-4 col-sm-6 col-12">
				<div class="content-item-wrap" :class="[licence.flag]" v-bind:style="itemStyle" ref="item">
					<a :href="buildUrl(licence)" @click="onClick(licence, false, $event)" target="_blank">
						<div class="content-item d-flex flex-column h-100" :class="parent.slug">
							<div class="content-icon flex-fill" v-bind:style="{backgroundImage: iconPath(licence.credit_id)}"></div>
							<div class="content-title">
								<p v-html="licence.title"></p>
							</div>
							<div class="badge" :class="[licence.flag]" v-if="licence.flag"><span v-html="licence.flag_text"></span></div>
						</div>
					</a>
				</div>
			</div>
		</template>
		<div v-else class="col col-12">
			<spinner></spinner>
		</div>
	</div>
</template>

<script>
	import libraryItem from '../library-item'

	export default {
		mixins: [libraryItem],
		props: ['slug'],
		mounted: function () {
            this.loadLicences(this.slug, 'order');
		},
	}
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/CollectionMulti.vue